export default __webpack_public_path__ + "static/media/iphonex.643e7399.svg";